import { ApiError } from '../../../api/client';

/**
 * Puts API validation details (`body.name: Required`) under the matching form fields. Returns
 * true when at least one detail was mapped (so a toast is not needed for those).
 */
export function applyApiErrors<F extends string>(
  error: unknown,
  setError: (field: F, e: { type: string; message: string }) => void,
  toField: (path: string) => F | null,
): boolean {
  if (!(error instanceof ApiError)) return false;
  let mapped = false;
  for (const d of error.details) {
    const f = toField(d.path);
    if (f) {
      setError(f, { type: 'server', message: d.message });
      mapped = true;
    }
  }
  return mapped;
}

/** `body.code` → `code` when it is one of the known fields. */
export function bodyField<F extends string>(known: readonly F[]) {
  return (path: string): F | null => {
    const f = path.replace(/^body\./, '').split('.')[0] ?? '';
    return (known as readonly string[]).includes(f) ? (f as F) : null;
  };
}
